var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"black-popup",on:{"click":_vm.blackPopClick}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }